<template>
  <AppDialog :is-open="isDialogOpened"
             size="l"
             @cancel="closeDialog"
  >
    <template #title>
      <slot name="header-text">
        {{ $t('common.dialogs.AppUnsavedChangesDialog.title') }}
      </slot>
    </template>

    <template #body>
      <slot name="body-text">
        <p>{{ $t("common.dialogs.AppUnsavedChangesDialog.body") }}</p>
      </slot>
    </template>

    <template #footer>
      <v-spacer />

      <app-button
        type="outlined"
        variant="neutral"
        @click="$emit('discard')"
      >
        {{ $t('common.dialogs.AppUnsavedChangesDialog.noSave') }}
      </app-button>

      <app-button @click="$emit('save')">
        {{ $t('common.dialogs.AppUnsavedChangesDialog.save') }}
      </app-button>
    </template>
  </AppDialog>
</template>

<script>
import AppDialog from '@/common/dialogs/AppDialog.vue'
import { dialogMixin } from '@/mixins/dialogMixin'

export default {
  name: 'AppUnsavedChangesDialog',
  emits: ['save', 'discard'],
  components: { AppDialog },
  mixins: [dialogMixin],
}
</script>
